"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extensionByMimeType = exports.getFileExtension = exports.getFilenameWithoutExtension = exports.sanitizeFileName = exports.getFormattedFileSize = void 0;
const units = ['B', 'KB', 'MB', 'GB', 'TB'];
const getFormattedFileSize = (fileSizeBytes) => {
    let unitIndex = 0;
    while (fileSizeBytes > 1024 && unitIndex < units.length - 1) {
        fileSizeBytes = fileSizeBytes / 1024;
        unitIndex++;
    }
    return `${fileSizeBytes.toFixed(0)}${units[unitIndex]}`;
};
exports.getFormattedFileSize = getFormattedFileSize;
/**
 * Removes special characters from a file name to avoid issues opening
 * on mobile devices
 */
const sanitizeFileName = (fileName) => fileName.replace(/[:/]/g, '_');
exports.sanitizeFileName = sanitizeFileName;
const getFilenameWithoutExtension = (fileName) => {
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex < 0 ? fileName : fileName.substring(0, dotIndex);
};
exports.getFilenameWithoutExtension = getFilenameWithoutExtension;
const getFileExtension = (fileName) => {
    const parts = fileName === null || fileName === void 0 ? void 0 : fileName.split('.');
    if (parts && parts.length >= 2) {
        return parts[parts.length - 1];
    }
    return '';
};
exports.getFileExtension = getFileExtension;
// map taken from LikePaper iOS. helps us get the file extension from the MimeType
exports.extensionByMimeType = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/heic': 'heic',
    'application/msword': 'doc',
    'text/csv': 'csv',
    'image/bmp': 'bmp',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/json': 'json',
    'application/vnd.oasis.opendocument.presentation': 'odp',
    'application/vnd.oasis.opendocument.spreadsheet': 'ods',
    'application/vnd.oasis.opendocument.text': 'odt',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'image/svg+xml': 'svg',
    'text/plain': 'txt',
    'aplication/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/x-iwork-pages-sffpages': 'pages',
    'application/x-iwork-keynote-sffkey': 'key',
    'application/x-iwork-numbers-sffnumbers': 'numbers',
};
//# sourceMappingURL=file.js.map